import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover } from '@base-ui/react';
import { IconButton, Stack } from '@mui/material';
import { useRef } from 'react';
/** Launches and handles modal from an icon */
export const IconLaunchedModal = ({ icon, open, setOpen, children, stackProps }) => {
    const handleIconClick = (event) => {
        setOpen(!open);
    };
    const thisRef = useRef(null);
    return (_jsx(Stack, { ...stackProps, children: _jsxs(Popover.Root, { open, children: [_jsx(IconButton, { onClick: handleIconClick, ref: thisRef, sx: { visibility: open ? 'hidden' : undefined }, children: icon }), _jsx(Popover.Portal, { children: _jsx(Popover.Positioner
                    // z-index needs to be less than 100 (drawer is 100)
                    , { anchor: thisRef, align: 'start', side: 'inline-end', sideOffset: -40, style: { zIndex: 80 }, children: _jsx(Popover.Popup, { children: _jsx(Stack, { sx: {
                                    borderRadius: 1,
                                    backgroundColor: 'white',
                                    outline: 'solid',
                                    outlineWidth: 0.5,
                                    outlineColor: (t) => t.palette.action.disabled,
                                    boxShadow: (t) => t.shadows[3],
                                }, children: children }) }) }) })] }) }));
};
